























































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
import * as _ from "lodash";

@Component({
  components: {}
})
export default class IndicatorsComponent extends Vue {
  dialog: boolean = false;
  mappingDialog: boolean = false;
  selectedItem: any = {};
  newMapping: any = {};
  action: string = "";
  selectedType: string = "";
  expand: boolean = true;
  expanded: any = [];
  headers: any = _app.meEntityHeaders;
  editedIndex: number = -1;
  indMappingHeaders: any = _app.indicatorMappingHeaders;
  indicatorMappings: any = [];
  indicatorList: any = [];
  impacts: any = [];
  periodicity: any = {};
  unit: any = {};

  mounted() {
    this.$services.entity.getEntities().then((resp: any) => {
      this.impacts = resp;
    });
    this.$services.entity.getIndicatorMapping().then((resp: any) => {
      this.indicatorMappings = resp;
    });
    this.$services.entity.getIndicators().then((resp: any) => {
      this.indicatorList = resp;
    });
  }

  /** Add new item */
  addItem(item) {
    this.action = "add";

    item = item || {};
    const Level: number = (item.Level || 0) + 1;
    const ParentId: number = item.ME_EntityId;
    const Hierarchy: string = item.hierarchy;
    this.selectedItem = Object.assign({}, { ParentId, Level, Hierarchy });
    this.getSelectedType(Level);

    this.dialog = true;
  }

  /** Edit the selected item */
  editItem(item) {
    this.action = "edit";

    this.selectedItem = item;
    this.editedIndex = this.impacts.indexOf(this.selectedItem);
    this.getSelectedType(item.Level);

    this.dialog = true;
  }

  /** delete the entity */
  deleteItem(item) {
    // TO DO: Ask for confirmation
    this.editedIndex = this.impacts.indexOf(item);
    this.$services.entity.deleteEntity(item.ME_EntityId).then((record: any) => {
      this.impacts.splice(this.editedIndex, 1);
      this.selectedItem = {};
      this.action = "";
      this.dialog = false;
    });
  }

  /** Get the selected type based on the level */
  getSelectedType(level: number) {
    switch (level) {
      case 1:
        this.selectedType = "Goal";
        break;
      case 2:
        this.selectedType = "Objective";
        break;
      case 3:
        this.selectedType = "Category";
    }
  }

  /** Add the indicator mapping */
  addIndicatorMapping(item: any) {
    const { ME_EntityId } = item;
    this.newMapping = Object.assign({ ME_EntityId });
    this.mappingDialog = true;
  }

  /** Save the mapping */
  saveMapping() {
    this.$services.entity.createMapping(this.newMapping).then((record: any) => {
      this.indicatorMappings.push(record);
      this.newMapping = {};
      this.mappingDialog = false;
    });
  }

  /** get the selected indicators */
  selectedIndicators(id: number) {
    const selectedIndicators = this.indicatorMappings
      .filter(x => x.ME_EntityId === id)
      .map(x => x.ME_IndicatorId);
    return this.indicatorList
      .filter(x => selectedIndicators.includes(x.ME_IndicatorId))
      .sort((x, y) => x.Order - y.Order);
  }

  /** Cancel mapping */
  cancelMapping() {
    this.newMapping = {};
    this.mappingDialog = false;
  }

  /** Remove the indicator mapping */
  removeIndicatorMapping(entityId: number, indicatorId: number) {
    const deletedMapping = this.indicatorMappings.find(
      x => x.ME_EntityId === entityId && x.ME_IndicatorId === indicatorId
    );

    const deletedIndex = this.indicatorMappings.indexOf(deletedMapping);

    this.$services.entity
      .deleteMapping(deletedMapping.ME_IndicatorMappingId)
      .then(resp => {
        this.indicatorMappings.splice(deletedIndex, 1);
      });
  }

  /** get the unused indicators */
  get unUsedIndicators() {
    const usedIndicators = this.indicatorMappings.map(x => x.ME_IndicatorId);
    return this.indicatorList
      .filter(x => !usedIndicators.includes(x.ME_IndicatorId))
      .sort((x, y) => x.Order - y.Order);
  }

  get impacts_sorted() {
    return this.impacts.sort((a, b) => {
      const prevValue = a.Hierarchy.split(".")
        .map(a => a.padStart(5, "0"))
        .join(".");
      const nextValue = b.Hierarchy.split(".")
        .map(a => a.padStart(5, "0"))
        .join(".");
      return prevValue > nextValue ? 1 : nextValue > prevValue ? -1 : 0;
    });
  }

  /** Save ME entity */
  save() {
    if (this.action === "add") {
      this.$services.entity
        .createEntity(this.selectedItem)
        .then((record: any) => {
          this.impacts.push(record);
          this.selectedItem = {};
          this.action = "";
          this.dialog = false;
        })
        .catch(e => {
          console.error(e);
        });
    } else if (this.action === "edit") {
      this.$services.entity
        .updateEntity(this.selectedItem.ME_EntityId, this.selectedItem)
        .then((record: any) => {
          this.impacts[this.editedIndex] = record;
          this.selectedItem = {};
          this.action = "";
          this.dialog = false;
        });
    }
  }

  cancel() {
    this.dialog = false;
  }
}
